var textQuoteSliders = document.querySelectorAll('.wp-block-usventure-text-story-slider');
var numberTextQuoteSliders = textQuoteSliders.length;

for (let i = 0; i < numberTextQuoteSliders; i++) {
  (function(slider){
    var slideID = 'slide'+String(i);
    slider.setAttribute('id',slideID);

    var bulletCount = slider.querySelectorAll('.quote-slider .glide__slide').length;
		var bulletWrapper = slider.querySelector('.quote-slider .glide__bullets');

		if (bulletCount > 1) {
			for (let index = 0; index < bulletCount; index++) {
				const button = document.createElement('button');
				button.className = 'glide__bullet';
				button.setAttribute("data-glide-dir", '='+index);

				bulletWrapper.appendChild(button)
			}
		} else {
			bulletWrapper.style.display = 'none';
		}

    new Glide('#'+slideID, {
			autoplay: 100,
      type: 'carousel',
      perView: 1,
    }).mount()
  })(textQuoteSliders[i])
}